var _circle, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 17.8,
    r: 16.8,
    stroke: "#E5E7DF",
    strokeWidth: 0.843243
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4152 22.1599H14.1618V16.7199C14.1618 14.3027 15.9752 13.0932 17.7876 13.0932H17.7894C19.6018 13.0932 21.4152 14.3027 21.4152 16.7199V22.1599ZM18.6952 24.8799C18.6952 25.3804 18.289 25.7866 17.7885 25.7866C17.288 25.7866 16.8818 25.3804 16.8818 24.8799V23.9732H18.6952V24.8799ZM23.2285 21.2532V16.7199C23.2285 13.4985 21.0815 11.7106 18.6952 11.3515V9.46655H16.8818V11.3515C14.4955 11.7106 12.3485 13.4985 12.3485 16.7199V21.2532C12.3485 21.7537 11.9423 22.1599 11.4418 22.1599C10.9413 22.1599 10.5352 22.5661 10.5352 23.0666C10.5352 23.567 10.9413 23.9732 11.4418 23.9732H15.0685V24.8799C15.0685 26.3822 16.2861 27.5999 17.7885 27.5999C19.2908 27.5999 20.5085 26.3822 20.5085 24.8799V23.9732H24.1352C24.6356 23.9732 25.0418 23.567 25.0418 23.0666C25.0418 22.5661 24.6356 22.1599 24.1352 22.1599C23.6347 22.1599 23.2285 21.7537 23.2285 21.2532Z",
    fill: "#AAB5C5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14795_133350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 16,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4152 22.1599H14.1618V16.7199C14.1618 14.3027 15.9752 13.0932 17.7876 13.0932H17.7894C19.6018 13.0932 21.4152 14.3027 21.4152 16.7199V22.1599ZM18.6952 24.8799C18.6952 25.3804 18.289 25.7866 17.7885 25.7866C17.288 25.7866 16.8818 25.3804 16.8818 24.8799V23.9732H18.6952V24.8799ZM23.2285 21.2532V16.7199C23.2285 13.4985 21.0815 11.7106 18.6952 11.3515V9.46655H16.8818V11.3515C14.4955 11.7106 12.3485 13.4985 12.3485 16.7199V21.2532C12.3485 21.7537 11.9423 22.1599 11.4418 22.1599C10.9413 22.1599 10.5352 22.5661 10.5352 23.0666C10.5352 23.567 10.9413 23.9732 11.4418 23.9732H15.0685V24.8799C15.0685 26.3822 16.2861 27.5999 17.7885 27.5999C19.2908 27.5999 20.5085 26.3822 20.5085 24.8799V23.9732H24.1352C24.6356 23.9732 25.0418 23.567 25.0418 23.0666C25.0418 22.5661 24.6356 22.1599 24.1352 22.1599C23.6347 22.1599 23.2285 21.7537 23.2285 21.2532Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14795_133350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.20312,
    y: 6.2666,
    width: 25.6,
    height: 25.6,
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderedNotification);
export default __webpack_public_path__ + "static/media/bordered_notification.b72d8e6902b7f0bf4968af1d20f766ad.svg";
export { ForwardRef as ReactComponent };